import axios from 'axios';

export default function setAxiosDefaults () {
    axios.defaults.headers.common.primary = false;
}
